import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getPrivateMenu, getPublicMenu } from 'redux/actions/pagesActions';
import { logoutUser } from 'redux/actions/authActions';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import { Theme } from 'utils/Theme';
import { NavLink } from 'react-router-dom';
import * as Icon from 'react-feather';
import PropTypes from 'prop-types';
import { isEmpty, filter, map } from 'lodash';
import { setQlikOptions } from 'redux/actions/qlikActions';
import clsx from 'clsx';

/**
 * @todo - Hacked in menu. Need to add Icon selection to page builder to be able assign an icon to the page for rendering
 */

const styles = Theme();

class DynamicSideMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: null,
            loading: true,
            auth: null,
        };
    }

    componentDidMount() {
        const {
            // eslint-disable-next-line react/prop-types
            auth: { isAuthenticated },
            menu,
            getPublicMenu,
            getPrivateMenu,
            settings,
        } = this.props;

        if (isAuthenticated) {
            !menu && getPrivateMenu();
        } else if (settings.publicAccess) {
            !menu && getPublicMenu();
            return;
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let { menu, loading, auth } = prevState;

        if (nextProps.pages) {
            menu = nextProps.pages.menu;
        }

        if (loading !== nextProps.loading) {
            loading = nextProps.loading;
        }

        return { menu, loading, auth };
    }

    render() {
        const { menu } = this.state;
        const { classes, match } = this.props;

        return (
            <nav>
                <ul className="c-sidebar__list">
                    {!isEmpty(menu) &&
                        menu.map((page) => {
                            const IconTag = Icon[page.icon || 'ChevronRight'];
                            const isActiveOrParent =
                                page._id === match.params.id ||
                                !isEmpty(
                                    filter(
                                        page.childPages,
                                        (child) => child._id === match.params.id
                                    )
                                );

                            return (
                                (page.hasContent || page.childPages) && (
                                    <li
                                        key={page._id}
                                        className={clsx(
                                            'c-sidebar__item',
                                            `${
                                                !isEmpty(page.childPages)
                                                    ? 'has-submenu'
                                                    : ''
                                            }`
                                        )}
                                    >
                                        {!isEmpty(page.childPages) && (
                                            <a
                                                href={`#LinkItem_${page._id}`}
                                                data-toggle={'collapse'}
                                                aria-expanded={'false'}
                                                aria-controls={
                                                    'sidebar-submenu'
                                                }
                                                className={clsx(
                                                    'c-sidebar__link',
                                                    isActiveOrParent &&
                                                        `collapse is-active  ${classes.isActive}`
                                                )}
                                            >
                                                {page.icon && (
                                                    <IconTag
                                                        className={clsx(
                                                            isActiveOrParent &&
                                                                classes.isActive,
                                                            'u-mr-xsmall'
                                                        )}
                                                    />
                                                )}
                                                {page.title}
                                            </a>
                                        )}
                                        {isEmpty(page.childPages) && (
                                            <NavLink
                                                exact
                                                to={`/pages/${page._id}`}
                                                activeClassName={`is-active ${classes.isActive}`}
                                                className={clsx(
                                                    'c-sidebar__link',
                                                    isActiveOrParent &&
                                                        `is-active ${classes.isActive}`
                                                )}
                                            >
                                                <IconTag
                                                    className={clsx(
                                                        'u-mr-xsmall',
                                                        `${
                                                            match.url.toLowerCase() ===
                                                                `/pages/${page._id}` &&
                                                            classes.isActive
                                                        } `
                                                    )}
                                                ></IconTag>
                                                {page.title}
                                            </NavLink>
                                        )}

                                        {!isEmpty(page.childPages) && (
                                            <div>
                                                <ul
                                                    className={`c-sidebar__list collapse ${
                                                        isActiveOrParent &&
                                                        ' show is-active '
                                                    }`}
                                                    id={`LinkItem_${page._id}`}
                                                >
                                                    {page.hasContent && (
                                                        <li>
                                                            <NavLink
                                                                exact
                                                                activeClassName={`is-active ${classes.isActive}`}
                                                                className={clsx(
                                                                    'c-sidebar__link u-ml-xsmall',
                                                                    isActiveOrParent &&
                                                                        page._id ===
                                                                            match
                                                                                .params
                                                                                .id &&
                                                                        `is-active ${classes.isActive}`
                                                                )}
                                                                to={`/pages/${page._id}`}
                                                            >
                                                                {page.title}
                                                            </NavLink>
                                                        </li>
                                                    )}
                                                    {map(
                                                        page.childPages,
                                                        (
                                                            { _id, title },
                                                            index
                                                        ) => {
                                                            const activeChild =
                                                                _id ===
                                                                match.params.id;
                                                            return (
                                                                <li key={index}>
                                                                    <NavLink
                                                                        exact
                                                                        activeClassName={`is-active ${classes.isActive}`}
                                                                        className={clsx(
                                                                            'c-sidebar__link u-ml-xsmall',
                                                                            activeChild &&
                                                                                `is-active ${classes.isActive}`
                                                                        )}
                                                                        to={`/pages/${_id}`}
                                                                    >
                                                                        {title}
                                                                    </NavLink>
                                                                </li>
                                                            );
                                                        }
                                                    )}
                                                </ul>
                                            </div>
                                        )}
                                    </li>
                                )
                            );
                        })}
                </ul>
            </nav>
        );
    }
}

DynamicSideMenu.propTypes = {
    logoutUser: PropTypes.func,
    classes: PropTypes.object,
    pages: PropTypes.object,
    getPrivateMenu: PropTypes.func,
    getPublicMenu: PropTypes.func,
    history: PropTypes.object,
    settings: PropTypes.object,
    match: PropTypes.object,
    menu: PropTypes.array,
    loading: PropTypes.bool,
    isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    pages: state.pages,
    settings: state.settings,
    menu: state.pages?.menu,
    qsServer: state.qsServer,
    loading: state.pages?.loading,
    isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
    setQlikOptions,
    getPrivateMenu,
    logoutUser,
    getPublicMenu,
})(withStyles(styles)(withRouter(DynamicSideMenu)));
